import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import AOS from 'aos';
import FullCalendar from '@fullcalendar/react';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import listPlugin from '@fullcalendar/list';
import AvatarDefault from './default-avatar.png';
import 'aos/dist/aos.css';
import './biblioteca.css';
import { UsersService } from '../../services/user';
import $ from "jquery";

import {
  HeaderShelf,
  ShelfFeaturedBanner,
  ShelfRecentReadings,
  ShelfYouMightLike,
  SidebarRoundedIcons,
  IaBot,
  IaBotReadingList,
  Categories,
  Card,
  Menu,
  CoinsAndBadges,
  Webview,
  OfflineTooltip,
  OfflineMessageView,
  ArchiveCategories,
  Footer
} from '../../components';
import { Utils } from '../../utils/utils';
export default class ViewHome extends Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();
    this.customizedRef = React.createRef();

    this.state = {
      "render_coins_and_badges": false,
      "coins": null,
      "courses": null,
      "user": null,
      "active_project": null,
      "customization": null,
      "active_tab": null,
      "events": null,
      "posts": null,
      "selected_blog_post": null,
      "dates_expanded_list": [Utils.localeDate(new Date())],
      "avatarFile": null,
      "avatarUrl": null,
      "optative_disciplines_expanded": false,
      "api_context": null,
      "books": null,
      "render_ai_search": false,
      "render_search_options": false,
      "search_value": ""
    }

    this.onUpdateProfile = this.onUpdateProfile.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      if (this.state.render_search_options) {
        this.setState({ "render_search_options": false });
      }
      if (this.state.render_ai_search) {
        this.setState({ "render_ai_search": false });
      }
    }
  }

  componentWillMount() {
    this.redirectToLogin();
  }


  redirectToLogin() {
    var user = UsersService.getUser();
    if (user === null) {
      window.location = window.location.origin + window.location.pathname + "#/login";
    } else {
      this.continueRequests();
    }
  }

  handleSearchChange(event) {
    this.setState({
      "search_value": event.target.value
    });
  }

  continueRequests() {
    this.getBooks();
    this.getApiContext();
    this.redirectToTab();
    this.getUser();
    this.getCourses();
    AOS.init({
      // anchorPlacement: 'top-bottom'
      offset: -50
    });
  }

  async getApiContext() {
    const response = await fetch("./api_context.json");
    const config = await response.json();
    this.setState({
      "api_context": config
    })
  }

  async getBooks() {
    // var recentReadings = await Sdk.Api.dynamic.bridge(`/cms/v1.1/managed/content/available?include_properties=true&include_entities=true&order_consumption=desc&only_new_contents=true&page_size=30`);
    var books = await Sdk.Api.dynamic.bridge(`/cms/v1.1/managed/content/available?include_properties=true&include_entities=true&order_consumption=desc&only_new_contents=true&page_size=5000`);

    this.setState({
      "books": books
    })
  }

  redirectToTab() {
    var tab = Utils.getUrlParam("tab");
    if (tab !== null) {
      this.setState({
        "active_tab": tab
      })
    }
  }

  startAutoScroll() {
    setTimeout(() => {
      const container = document.querySelector('.rdp-react-template-view-biblioteca-content');
      const elementHeaders = document.getElementsByClassName('fc-list-day');
      const header = document.querySelector('.rdp-react-template-component-header');
      const menu = document.querySelector('.rdp-react-template-component-categories');

      const day = new Date().getDay();

      if (elementHeaders && container && header && menu) {
        const currentHeader = elementHeaders[day - 1];
        if (currentHeader) {
          const currentHeaderRect = currentHeader.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const targetPosition = currentHeaderRect.top - containerRect.top
          const discount = header.clientHeight + menu.clientHeight
          container.scrollBy(0, (targetPosition - discount) + 40);
        }
      }
    }, 500)
  }

  componentDidMount() {
    this.updateDownloadProgress();
    document.addEventListener("keydown", this.handleKeyDown);
  }

  toggleShowEvents(dateCompare, hidden = true) {
    const _this = this;
    const { events } = this.state;

    _this.setState({
      events: events.map(item => {
        const dateStart = Utils.parseDateString(item.start);
        const start = Utils.localeDate(dateStart);
        if (start === dateCompare) {
          return { ...item, hidden: hidden }
        }
        return item;
      }),
    })
  };

  refreshCustomizationWhenNaviationWeek() {
    const _this = this;
    const buttonsToolbar = document.getElementsByClassName('fc-button-group');
    const [prev, next] = Array.from(buttonsToolbar);

    try {
      (prev || next).onclick = () => {
        _this.customizeCalendar();
      }
    } catch (e) {

    }
  }

  customizeCalendar() {
    const _this = this;
    if (this.state.active_tab === "study") {
      const elements = document.getElementsByClassName('fc-list-day-side-text');
      const elementHeaders = document.getElementsByClassName('fc-list-day');

      const chevronIconHtml = `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 14a.997.997 0 01-.707-.293l-5-5a.999.999 0 111.414-1.414L10 11.586l4.293-4.293a.999.999 0 111.414 1.414l-5 5A.997.997 0 0110 14z" fill="#fff"/></svg>`

      Array.from(elements).forEach((element, i) => {
        const stringDate = element.innerText;
        const chevron = document.createElement('span');

        element.style.display = 'flex';
        element.style.marginBottom = "-4px";
        chevron.style.transition = "0.5s";
        chevron.style.marginLeft = "10px";
        chevron.style.marginTop = "-2px";

        chevron.classList.add("react-chevron-icon-down");
        chevron.innerHTML = chevronIconHtml;
        const dateFrom = Utils.parseDateString(stringDate);
        const toDate = Utils.localeDate(dateFrom);

        const eventInitExpanded = _this.state.events.find(item => {
          var itemStart = item.start;
          if (typeof itemStart === "string") itemStart = new Date(itemStart);
          const start = Utils.localeDate(itemStart);
          return start === toDate;
        });

        if (eventInitExpanded && eventInitExpanded.hidden === false) {
          chevron.classList.toggle("expanded");
          chevron.style.transform = "rotate(180deg)";
        };

        elementHeaders[i].onclick = () => {
          if (chevron.classList.contains("expanded")) {
            chevron.style.transform = "rotate(0)";
            _this.toggleShowEvents(toDate, true);
          }

          else {
            chevron.style.transform = "rotate(180deg)";
            _this.toggleShowEvents(toDate, false);
          }
          chevron.classList.toggle("expanded")
        };

        element.appendChild(chevron);
      })
    }
  }

  componentDidUpdate() {
    // if(this.state.events && !this.customizedRef.current) {
    //   this.customizedRef.current = true;
    //   this.setState({ events: this.state.events.map(item => {
    //     const start = Utils.localeDate(item.start);
    //     const today = Utils.localeDate(new Date());
    //     return {
    //       ...item,
    //       hidden: start !== today,
    //     }
    //   })}, () => {
    //     this.customizeCalendar();
    //     this.refreshCustomizationWhenNaviationWeek();
    //     this.startAutoScroll();
    //   })
    // }
  }

  componentWillUnmount() {
    var _this = this;
    window.document.removeEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  updateDownloadProgress() {
    var _this = this;
    window.document.addEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
  }

  handleCourseDownloadedUpdated(event) {
    this.getNodes(this.state.courses);
    const { uid } = event.detail;
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  async getUser() {
    // var userDetails = await UsersService.getUserDetails();
    var userDetails, avatar;

    if (Utils.recoverBridge(`/auth/v1.0/user/me`) !== null) {
      userDetails = Utils.recoverBridge(`/auth/v1.0/user/me`);
      avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);

      this.setState({
        "user": {
          ...(userDetails || {}),
          avatar,
        }
      });
    }

    userDetails = await Utils.bridgeAndStore(`/auth/v1.0/user/me`, null, 'GET');

    // var userDetails = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    if (userDetails.detail.name.search("Guest") > -1) {
      this.signOut();
    }
    avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);
    this.setActiveProject(userDetails.projects);

    this.setState({
      "user": {
        ...(userDetails || {}),
        avatar,
      }
    });
  }

  setActiveProject(projects) {
    var activeProjectUid = UsersService.getActiveProjectUid();

    if (activeProjectUid !== null) {
      var activeProject = projects.find(project => project.uid === activeProjectUid);
      this.setState({
        "active_project": activeProject
      });

      // this.setCustomization(activeProject)
    };
  }

  async setCustomization(activeProject) {
    var customizationConnector = activeProject.connectors.find(connector => connector.type === "Customization_1");

    if (window.localStorage.getItem(`connector-${customizationConnector.uid}`)) {
      this.setState({
        "customization": JSON.parse(window.localStorage.getItem(`connector-${customizationConnector.uid}`)).configuration.configs
      });
    };

    if (customizationConnector !== undefined) {
      var connector = await UsersService.getConnector(customizationConnector.uid);
      this.setState({
        "customization": connector.configuration.configs
      });
    }
  }

  async getCourses() {
    // var courses = await UsersService.getCourses();
    var courses, nodes;
    if (Utils.recoverBridge(`/cms/v1.1/learning/courses?page_size=500`) !== null) {
      courses = Utils.recoverBridge(`/cms/v1.1/learning/courses?page_size=500`);
      courses.result = courses.result.filter(course => course.access_status !== "Blocked");
      nodes = await this.getNodes(courses.result);
    };

    courses = await Utils.bridgeAndStore(`/cms/v1.1/learning/courses?page_size=500`, null, 'GET');
    courses.result = courses.result.filter(course => course.access_status !== "Blocked");
    nodes = await this.getNodes(courses.result);
    // this.setState({
    //   "courses": courses.result
    // });
  }

  createNodesEventsWithDates(nodes, overrides, courseStatus, course) {
    var events = [];
    var statusActivities = courseStatus.activities;

    for (var i = 0; i < nodes.length; i++) {
      var childs = nodes[i].childs;
      for (var j = 0; j < overrides.length; j++) {
        for (var k = 0; k < childs.length; k++) {
          var activities = childs[k].activities;
          for (var l = 0; l < activities.length; l++) {
            for (var m = 0; m < statusActivities.length; m++) {
              if (activities[l].uid === statusActivities[m].uid) {
                activities[l].status = statusActivities[m].status;
                if (statusActivities[m].local_storage) {
                  activities[l].local_storage = statusActivities[m].local_storage;
                };
              };
            };
          };

          if (childs[k].uid === overrides[j].uid) {
            childs[k].interaction_start = overrides[j].interaction_start;
            childs[k].parent_title = nodes[i].data.title;
            nodes[i].hasLessons = true;

            events.push({
              "title": childs[k].data.title,
              "start": new Date(overrides[j].interaction_start),
              "extendedProps": {
                "title": childs[k].data.title,
                "parent_title": nodes[i].data.title,
                "activities": activities,
                "course_uid": course.course.uid,
                "course_title": course.course.title,
                "register_uid": course.register.uid,
                "module_uid": nodes[i].uid,
                "is_past_date": new Date(overrides[j].interaction_start).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
              }
            })
            // "/player/:courseUid/:registerUid/:moduleUid/:activityUid"
          };
        };
      };
    };

    return events;
  }

  injectCourseDownloadProgress(activities) {
    var downloading = [];
    var downloaded = [];

    for (var i = 0; i < activities.length; i++) {
      if (activities[i].local_storage) {
        if (activities[i].local_storage.state === "Downloading") {
          downloading.push(activities[i]);
        };
        if (activities[i].local_storage.state === "Downloaded") {
          downloaded.push(activities[i]);
        };
      };
    };

    return downloaded.length / activities.length * 100;
  }

  uniqueEvents(events) {
    let setObj = new Set(events.map(JSON.stringify));
    let output = Array.from(setObj).map(JSON.parse);

    return output;
  }

  async getNodes(courses) {
    var _this = this;

    var events = [];

    for (var i = 0; i < courses.length; i++) {
      var registerUid = courses[i].register.uid;
      var courseStatus = null;
      var courseTree = null;

      if (Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`) !== null) {
        courseStatus = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`);
      };

      if (Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`) !== null) {
        courseTree = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`);
      };

      if (courseStatus !== null && courseTree !== null) {
        var overrides = courseStatus.nodes.filter(node => node.interaction_start !== null)
        courses[i].progress = _this.injectCourseDownloadProgress(courseStatus.activities);
        events = events.concat(_this.createNodesEventsWithDates(courseTree, overrides, courseStatus, courses[i]));
      }

      this.setState({
        "courses": courses,
        "events": events
      })
    }

    for (var i = 0; i < courses.length; i++) {
      var registerUid = courses[i].register.uid;
      var courseStatus = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET');
      var courseTree = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`, null, 'GET');
      var overrides = courseStatus.nodes.filter(node => node.interaction_start !== null)
      courses[i].progress = _this.injectCourseDownloadProgress(courseStatus.activities);
      events = events.concat(_this.createNodesEventsWithDates(courseTree, overrides, courseStatus, courses[i]));
    }

    this.setState({
      "courses": courses,
      "events": this.uniqueEvents(events)
    })
  }

  formatCoins(numb) {
    return numb.toLocaleString('pt-br');
  }

  onClick(type, uid) {
    window.location = window.location.origin + window.location.pathname + "#/" + type + "/" + uid;
  }

  onCoinsClick() {
    this.setState({
      "render_coins_and_badges": true
    })
  }

  onCourseClick(courseUid, registerUid) {
    window.location = window.location.origin + window.location.pathname + "#/curso/" + courseUid + "/" + registerUid;
  }

  getCustomizationConfig(uid, prop) {
    var config = null;
    var customization = this.state.customization;

    if (customization) {
      config = JSON.parse(customization.find(item => item.uid === uid).value).find(obj => obj.uid === prop).value;
    }

    return config;
  }

  getProgress(course) {
    return Math.round(course.activities.total_status_completed / course.activities.total_activities * 100)
  }

  onActivityClick(courseUid, registerUid, moduleUid, activityUid) {
    window.location = window.location.origin + window.location.pathname + "#/player/" + courseUid + "/" + registerUid + "/" + moduleUid + "/" + activityUid;
  }

  downloadedActivity(activity) {
    var isDownloaded = false;

    if (activity.local_storage && activity.local_storage.state === "Downloaded") {
      isDownloaded = true;
    };

    return isDownloaded;
  }

  renderIcon(name) {
    if (name.search("Conteúdo WEB") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon conteudo-web"></span>
    } else if (name.search("Leitura:") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon leitura"></span>
    } else if (name.search("Avaliação Final") > -1 || name.search("Avaliação Virtual") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon prova-presencial"></span>
    } else if (name.search("Teleaula:") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon teleaula"></span>
    } else if (name.search("Live:") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon live"></span>
    } else if (name.search("Engajamento AVA:") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon engajamento-ava"></span>
    } else if (name.search("Prova Presencial da Disciplina") > -1) {
      return <span className="rdp-react-template-view-biblioteca-calendar-activity-icon prova-presencial"></span>
    }

  }

  renderEventContent(eventInfo) {
    var _this = this;
    // "extendedProps": {
    //   "title": childs[k].data.title,
    //   "parent_title": nodes[i].data.title,
    //   "activities": activities,
    //   "course_uid": course.uid,
    //   "register_uid": course.register.uid,
    //   "module_uid": nodes[i].uid
    //   "is_past_date": true
    // }
    // })
    // "/player/:courseUid/:registerUid/:moduleUid/:activityUid"

    const {
      title,
      parent_title,
      activities,
      course_uid,
      course_title,
      register_uid,
      module_uid,
      is_past_date,
      hidden
    } = eventInfo.event.extendedProps;

    if (hidden) return;

    return <div className="rdp-react-template-view-biblioteca-calendar-item">
      {activities.filter(act => act.status === "Completed").length === activities.length &&
        <span className="rdp-react-template-view-biblioteca-calendar-item-status-icon success"></span>
      }
      {is_past_date && (activities.filter(act => act.status === "Completed").length < activities.length) &&
        <span className="rdp-react-template-view-biblioteca-calendar-item-status-icon warning"></span>
      }
      {!is_past_date && (activities.filter(act => act.status === "Completed").length < activities.length) &&
        <span className="rdp-react-template-view-biblioteca-calendar-item-status-icon clock"></span>
      }
      {/* <span className="rdp-react-template-view-biblioteca-calendar-item-name">{parent_title} / {title}</span> */}
      <span className="rdp-react-template-view-biblioteca-calendar-course-title">Disciplina: {course_title}</span>
      <span className="rdp-react-template-view-biblioteca-calendar-item-name">{parent_title}</span>
      <span className="rdp-react-template-view-biblioteca-calendar-item-subname">{title}</span>
      <ul className="rdp-react-template-view-biblioteca-calendar-activities">
        {activities && activities.map(function (activity, index) {
          return <li key={index} onClick={() => _this.onActivityClick(course_uid, register_uid, module_uid, activity.uid)} className={`rdp-react-template-view-biblioteca-calendar-activity ${_this.downloadedActivity(activity) ? "downloaded" : ""} ${activity.status} ${activities.length === (index + 1) ? "last" : ""}`}>
            {_this.renderIcon(activity.name)}
            <span className="rdp-react-template-view-biblioteca-calendar-activity-label">{activity.name}</span>
          </li>
        })}
      </ul>
    </div>
  }

  formatBlogDate(dat) {
    // var splited = dat.split("T")[0].split("-");
    // return `${splited[2]}/${splited[1]}/${splited[0]}`;
    return dat;
  }

  onBlogPostClick(url) {
    this.setState({
      "selected_blog_post": url
    })
  }

  async onUpdateProfile() {
    const { avatarFile, user } = this.state;
    const formData = new FormData();

    if (!avatarFile || !user) return;

    formData.append('profile', avatarFile);

    await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/me/thumb`, formData, "PUT")
      .then(() => {
        this.setState({
          active_tab: 'study',
          user: {
            ...user, avatar: URL.createObjectURL(avatarFile)
          }
        });
      })
      .catch(err => {
        console.log(err);
      })
  };

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  optativeSubscription() {
    this.setState({
      "optative_disciplines_expanded": false
    });
    $(`[data-id="162f389d-a326-ef11-86d4-00224821ba75"`).show();
  }

  getCustomOptions() {
    // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6IiIsIm5hbWUiOiJBZG1pbiIsIm9pZCI6Ijg2Y2RlMzBhLWY4NTYtZjAxMS04ZjdjLTAwMjI0ODM3ZWE2OCIsImRpcmVjdG9yeSI6ImY2NTRhNmQ0LWY3NTYtZjAxMS04ZjdjLTAwMjI0ODM3ZWE2OCIsImFwaW0iOiIwRjk0NTQyRi0wRkMyLTQ1RDAtQjA4RC1FQzIyODNENkUzNzQiLCJkaXJuIjoiU2VuYWkgQ05JIiwicm9sZSI6WyJWaWV3ZXIiLCJBZG1pbmlzdHJhdG9yR2xvYmFsIl0sImRjbiI6WyJINHNJQUFBQUFBQUFBd0JTQUszX0F3QUFBRFVBQUFBQUFHTTRNbVF6TURnNEZHdi1xY1BrMl9DRjNzRDdZZlJDXzl6aW9ENnBXalhrTENZSjFPX1VrS21nMjYxNHlFVE9pVmlPa29iOThqc05yUjdRNWI5dGZ3NHlTNkVNcWQ5VWlnQUFBUF9fIiwiSDRzSUFBQUFBQUFBQTJKbVlHQXdaUUNCWkF1akZHTURDd3NUcFNlblA3aTNOeXZZMzdqZXJLd1RGMlRzWDc5Sjl1R3JocldYZHJXeExiRUp2SHNvMEVmNTk4YmoyemNiN0ttTEYzbWx6TEdvYVVMU0xja1pmSWxwR1FjekFRQUFBUF9fIiwiSDRzSUFBQUFBQUFBQTJKbVlHQXdaUUNCWkF1akZHTURDNHVUd2NlX1hQZy1PMkpUZlBhRDhwYmJtYmRxVTlmZFZuajZjNDZrME5mTzk1bV85LXk5VzN0QlBLVEYtUFZpX2REdWtMMFZVNE1YQmdZX3NuSmQxWnpDeGp5dkRnQUFBUF9fIiwiSDRzSUFBQUFBQUFBQTJKbVlHQXdaUUNCWkF1akZHTURDNHVIeXBQNlBzWC1pWEp4bW5oMGYtWWpwaTRYSDEyN1diWGJUeG12U1JUYWtlbzE2OEVtSzBtdUdhbkt2cm1LT25YdG9zYUdsVm1XLVQzT3o2d3ZXVjVmMUhrZEFBQUFfXzgiLCJINHNJQUFBQUFBQUFBMkptWUdBd1pRQ0JaQXVqRkdNREM0dE5LMk9QZW0zOGJuMVFtRzhkNjZhQWxjZTkybGFuTDdyZzlPUDVQWjVkRzRYcTFpYUp4Wl9ibEI2ZFBObHcxWmU2c25YZlhlVml1WktXLTlWS0ZzbDIzZHY1R1FBQUFQX18iXSwic2NwIjpbIkg0c0lBQUFBQUFBQUF3Q1NBRzNfQXdBQUFId0FBQUFBQURneFpqSTRNV0UxY3JQMGx3WHMtWXk2ZURxTFpmQk5YTVF4Zlhia0kxTFpaV2E2M1hBSHBiZGVuVUpGRGNKUGRJS3VyQ1N5VS16NktFTmsyNDNYeGpjazRKWWJJSzJpZmdtN01uekxqUWVaaEgtNEtMSWRITXNhOUNZRnhmT3F6bXVBYzNieVRYYU9oalBCVHlLdVNMNTdtTlp4X0praHBZbWxvRmpvSXdueHF2ZU5xa19nZVI0QUFBRF9fdyIsIkg0c0lBQUFBQUFBQUF3QnlBSTNfQXdBQUFGTUFBQUFBQUdSaE9XRTFNamhrZEpITE5HZlZiUUNFekZkbExaNmU2TjRZa2JPUGdQYjdzT1loeE1seFlYa3RMYWtYUno0M2VHd0I0aUVJY05xa25lMUdtb3hPOVhVSHlQYTlFY21zYXJ3T200ZUhhRENPZUtDVHcxNS1QWDZoeFQ3c2xYdFJVZnROMi1LbTJpSjlBQUFBX184IiwiSDRzSUFBQUFBQUFBQXdCeUFJM19Bd0FBQUZNQUFBQUFBR1JoT1dFMU1qaGtkSkhMTkdmVmJRQ0V6RmRsTFo2ZTZHc3BvS21JUDlkX2Yxc2prT2lyal9fZE9HcC1lbjlZd2xiX2l5NEdUdF9nT05SUGVIbERxODBweG1VZFVCd1U5ZHpxSHFWYVJZWEViQkxlLXdXVi1Lc1hUbm91dlJxclAyS0NvNmxGUnVnaUFBQUFfXzgiXSwibmJmIjoxNzYzMDU0MDQ1LCJleHAiOjE3NjU2NDYwNDUsImlhdCI6MTc2MzA1NDA0NSwiaXNzIjoiaHR0cHM6Ly9hcGkuZGlnaXRhbHBhZ2VzLmNvbS5iciIsImF1ZCI6Ikdsb2JhbCJ9.-OGVM9K-y4do3RFu-gvutjTEQi9C6NmIqMsYqfuJCpg
    // return `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`;
    return `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`;
  }

  render() {
    var _this = this;
    const {
      user,
      render_ai_search,
      render_search_options,
      search_value
    } = this.state;

    const { name, first_name, last_name } = (user || { detail: {} }).detail;

    return (<div className="rdp-react-template-view-biblioteca">
      {/* <IaBot/> */}

      {render_search_options &&
        <div className="rdp-react-template-view-biblioteca-search-options">
          <div className="rdp-react-template-view-biblioteca-search-options-overlay" onClick={() => this.setState({ "render_search_options": false })}></div>
          <ul className="rdp-react-template-view-biblioteca-search-options-items">
            <li className="rdp-react-template-view-biblioteca-search-options-item" style={{
              backgroundImage: "none",
              paddingRight: "18px",
              cursor: "default"
            }}>
              <span className="rdp-react-template-view-biblioteca-search-options-item-icon metadata">🔎</span>
              <div className="rdp-react-template-view-biblioteca-search-options-item-data">
                <span className="rdp-react-template-view-biblioteca-search-options-item-title">Busca Estruturada por Metadados</span>
                <p className="rdp-react-template-view-biblioteca-search-options-item-description">
                  Permite localizar livros a partir de informações cadastrais como título, autor, editora, ISBN, ano de publicação, categorias, palavras-chave e outros metadados. Ideal para buscas objetivas e precisas.
                </p>
                <div className="header-shelf-search-container" style={{
                  width: "100%",
                  cursor: "inherit",
                  marginTop: "20px"
                }}>
                  <input
                    type="text"
                    placeholder="Encontre aqui o seu livro"
                    // placeholder="Descubra títulos com ajuda da IA"
                    className="header-shelf-search-input"
                    // value={searchValue}
                    onChange={this.handleSearchChange}
                    aria-label="Pesquisar livros por metadados"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && search_value.length >= 3) {
                        this.redirectTo(`search/term/1/${search_value}`)
                      }
                    }}
                    style={{
                      pointerEvents: "auto",
                      paddingLeft: "15px"
                    }}
                  />
                  <svg className="header-shelf-search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style={{
                      left: "unset",
                      right: "8px",
                      cursor: "pointer",
                      zIndex: "999",
                      pointerEvents: "auto",
                      opacity: search_value.length >= 3 ? "1" : "0.5"
                    }}
                    onClick={() => {
                      if (search_value.length >= 3) {
                        this.redirectTo(`search/term/1/${search_value}`)
                      }
                    }}
                  >
                    <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="#005496" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </li>
            {/* <li className="rdp-react-template-view-biblioteca-search-options-item inactive" onClick={() => {
               this.setState({
                "render_search_options": false,
                "render_ai_search": true
              })
            }}>
              <span className="rdp-react-template-view-biblioteca-search-options-item-icon ai">🤖</span>
              <div className="rdp-react-template-view-biblioteca-search-options-item-data">
                <span className="rdp-react-template-view-biblioteca-search-options-item-title">EM BREVE: Busca Inteligente por Conteúdo (IA)</span>
                <p className="rdp-react-template-view-biblioteca-search-options-item-description">
                  Utiliza Inteligência Artificial para compreender a intenção da busca e analisar o conteúdo completo dos livros, retornando resultados mesmo quando o termo pesquisado não aparece literalmente, mas está relacionado ao tema, contexto ou significado do texto.
                </p>
              </div>
            </li> */}
          </ul>
        </div>
      }

      {render_ai_search &&
        <IaBotReadingList
          booksData={this.state.books}
          textoExtraido={this.state.books}
          apiContext={this.state.api_context}
          accessToken={Sdk.authorization.credential.accessToken}
          aiConnector={Sdk.authorization.activeProject.connectors.find(conn =>
            conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)
          ) || {
            "features": [
              "IConnectorInstance",
              "IConnectorGenerativeIA",
              "IConnectorContextRequired",
              "IConnectorDetail"
            ],
            "internal_name": "Google IA",
            "name": "Vertex",
            "scope": "Project",
            "type": "Custom",
            "uid": "9d28a846-e6ca-f011-8197-0022483811fe"
          }}
          onBookSelect={(book) => this.redirectTo(`/book/${book.uid}`)}
          onClose={() => this.setState({ "render_ai_search": false })}
          customOptions={this.getCustomOptions()}
        />
      }

      {/* <IaBot
        onClose={() => this.onToggleAiBot()}
        aiConnector={Sdk.authorization.activeProject.connectors.find(conn => 
          conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)
        )}
        textToSpeechConnector={Sdk.authorization.activeProject.connectors.find(conn =>
          conn.features && conn.features.find(feat => feat.search("IConnectorTextToSpeech") > -1)
        )}
        customOptions={this.getCustomOptions()}
        apiContext={this.state.api_context}
        textoExtraido={this.state.books}
      /> */}

      <div
        className="rdp-react-template-view-biblioteca-header"
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          right: "0px",
          width: "100%",
          height: "100px",
          zIndex: 1
        }}
      >
        <HeaderShelf
          onSignOut={() => { this.signOut() }}
          onEditClick={() => {
            window.location.hash = 'perfil';
          }}
          name={user && user.detail && user.detail.name.split(" ")[0]}
          level="Nível 1"
          coins={this.state.coins}
          coinsLabel="BV Coins"
          onCoinsClick={() => this.onCoinsClick()}
          avatar={user && user.avatar ? user.avatar : undefined}
          onSearchClick={() => this.setState({ "render_search_options": true })}
        // onSearchClick={() => this.setState({"render_ai_search": true})}
        />
      </div>

      <div
        className="rdp-react-template-view-biblioteca-sidebar"
        style={{
          width: "50px",
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "0px"
        }}
      >
        <SidebarRoundedIcons />
      </div>

      <div
        className="rdp-react-template-view-biblioteca-main"
        role="main"
        style={{
          position: "fixed",
          top: "100px",
          bottom: "0px",
          left: "50px",
          right: "0px",
          overflowX: "hidden",
          overflowY: "auto"
        }}
      >
        <ShelfFeaturedBanner />
        <ShelfRecentReadings />
        <ShelfYouMightLike />
        <ArchiveCategories />
        <Footer />
      </div>
    </div>);
  }
}
